import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@mui/styles'

import lang from 'lang'
import config from 'config'
import Loader from '@/modules/base/components/loader/loader'
import CheckIcon from 'assets/images/icons/check.svg'
import BuhlBankIcon from '@assets/images/banking/buhlBank.svg?url'
import { BankingService } from '../../services'
import { Title } from '@/modules/base/components/texts'
import { ModalBig } from '@/modules/base/components/modal'
import { Checkbox } from '@/modules/base/components/inputs'
import { CancelButton, ButtonIconSquare } from '@/modules/base/components/buttons'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const { agbUrl, privacyUrl } = config

class AgreementModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      agrees: false,
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleConfirm = this.handleConfirm.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillUnmount() {
    this.setState({ agrees: false })
  }

  handleChange(value, name) {
    this.setState({ [name]: value })
  }

  handleTermsOfUseClick(target) {
    window.open(target, '_blank')
  }

  handlePrivacyClick(target) {
    window.open(target, '_blank')
  }

  handleConfirm() {
    const { agrees } = this.state
    const { token, handleConfirm, handleError } = this.props

    if (!agrees) return

    this.setState({ loading: true }, () => {
      return BankingService.psd2.agreements.approve(token)
        .then(handleConfirm)
        .catch(handleError)
        .done(() => this.setState({ isLoading: false }))
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    this.handleConfirm()
  }

  render() {
    const { agrees, loading } = this.state
    const { text, classes, handleAbort } = this.props

    const buttons = [
      <CancelButton
        key='cancel'
        type='cancel'
        label={lang.cancelButtonLabel}
        onClick={handleAbort} />,
      <ButtonIconSquare
        key='confirm'
        customClass={classes.actionButton}
        type='submit'
        icon={CheckIcon}
        label={lang.approveButtonLabel}
        disabled={!agrees}
        onClick={this.handleSubmit} />,
    ]

    return (
      <ModalBig
        disableEscapeKeyDown
        disableBackdropClick
        open={true}
        actions={buttons}
        onClose={handleAbort}>
        <Loader customClass={classes.loader} visible={loading} />
        <div className={classes.titleWrapper}>
          <Title className={classes.title}>{lang.bankingAgreementModalTitle}</Title>
          <SVGIcon svg={BuhlBankIcon} width='85px' height='25px' />
        </div>
        <div className={classes.content}>
          <div className={classes.description}>
            <p>{lang.bankingAgreementModalDescriptionLine1}</p>
            <p>{lang.bankingAgreementModalDescriptionLine2}</p>
            <p>
                            Es gelten unsere neuen <a href={agbUrl} target='_blank'>Nutzungsbedingungen</a> und
                            die <a href={privacyUrl} target='_blank'>Datenschutzerklärung</a> der {lang.companyName}.
            </p>
            <p>{lang.bankingAgreementModalDescriptionLine3}</p>
          </div>
          <hr className={classes.seperator} />
          <form className={classes.form} onSubmit={this.handleSubmit}>
            <Checkbox
              name='agrees'
              customClass={classes.checkbox}
              inputPosition="top"
              onChange={this.handleChange}>
              <div className={classes.checkboxLabel}>
                <span className={classes.checkboxLabelTitle}>buhl:Banking nutzen</span>
                <div className={classes.checkBoxLabelText} dangerouslySetInnerHTML={{ __html: text }} />
              </div>
            </Checkbox>
          </form>
        </div>
      </ModalBig>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    banking: {
      bankAccountList: { selectedBankAccount, contextMenu },
    },
  } = state

  return {
    selectedBankAccount,
    contextMenu,
  }
}

AgreementModal.defaultProps = {
  open: false,
}

const styles = theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  loader: {
    height: '100%',
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    padding: '0px 15px',
  },
  description: {
    padding: '0px 15px',
  },
  seperator: {
    background: theme.borderColor,
    width: '100%',
    height: 1,
    margin: '15px 0px',
  },
  form: {
    padding: '0px 15px',
    marginBottom: 25,
  },
  checkbox: {
    alignItems: 'flex-start',
  },
  checkboxLabel: {
    marginLeft: 10,
  },
  checkboxLabelTitle: {
    fontWeight: 600,
  },
  checkBoxLabelText: {
    fontSize: 9.5,
    marginTop: 10,
    marginLeft: -32,
  },
  actionButton: {
    marginLeft: 15,
  },
})

export default connect(mapStateToProps)(withStyles(styles)(AgreementModal))
